const _ = require('underscore');
const model = require('model/model');
const assignmentService = require('services/assignmentService');

const updateAssignmentsList = (updates, remove) => {
	let assignmentsList = model.get('skiAssignments') || [];
	let ski = {};
	assignmentsList = [...assignmentsList].filter(a => {
		if (a.rmsid === updates.rmsid) {
			ski = a;
		}
		return a.rmsid !== updates.rmsid;
	});

	if (!remove) {
		assignmentsList.push(_.assign(ski, updates));
	}

	model.set('skiAssignments', assignmentsList);
};

const getSKIProduct = (language = 'en') => {
	let l = language;
	return assignmentService.getReadingMindsetSnapshotProduct({ l }).then(product => {
		model.set('skiProduct', product);
	});
};

const getSKIActiveAssignment = cc => {
	return assignmentService.getReadingMindsetSnapshotAssignments({ cc }).then(assignments => {
		if (assignments && assignments.length) {
			assignments.some(s => {
				if (s && !s.ed) {
					return true;
				}
				return false;
			}, {});
		}
	});
};

const getSKIAssignments = cc => {
	return assignmentService.getReadingMindsetSnapshotAssignments({ cc }).then(assignments => {
		model.remove('skiAssignments');
		if (assignments && assignments.length) {
			model.set('skiAssignments', assignments);
		}
	});
};

const scheduleSKI = (cc, d, token) => {
	return assignmentService
		.createReadingMindsetSnapshotAssignment({
			cc,
			d,
			token
		})
		.then(resp => {
			if (resp && resp.rmsid) {
				updateAssignmentsList(resp);
			}
			return resp;
		});
};

const rescheduleSKI = (cc, d, rmsid, token) => {
	return assignmentService
		.editReadingMindsetSnapshotAssignment({
			cc,
			d,
			rmsid,
			token
		})
		.then(resp => {
			let ski = {
				rmsid,
				cc,
				d: d / 1000
			};
			updateAssignmentsList(ski);
		});
};

const cancelSKI = (cc, rmsid, token) => {
	return assignmentService
		.deleteReadingMindsetSnapshotAssignment({
			cc,
			rmsid,
			token
		})
		.then(resp => {
			updateAssignmentsList({ rmsid }, true);
		});
};

const endSKI = (cc, rmsid, token) => {
	return assignmentService
		.endReadingMindsetSnapshotAssignment({
			cc,
			rmsid,
			token
		})
		.then(resp => {
			updateAssignmentsList({
				rmsid,
				ed: Date.now() / 1000
			});
		});
};

const studentGetSKIAssignment = () => {
	let now = Date.now();
	return assignmentService.studentGetReadingMindsetSnapshotAssignment().then(resp => {
		if (resp && resp.d && now > resp.d * 1000) {
			model.set('skiAssignment', resp);
		}
	});
};

const submitSKI = (ans, l, rmsid, token) => {
	return assignmentService
		.studentSubmitReadingMindsetSnapshotAssignment({
			ans,
			l,
			rmsid,
			token
		})
		.then(resp => model.set('skiAssignment', resp));
};

const getSKIResults = (cc, rmsid) => {
	return assignmentService
		.getReadingMindsetSnapshotResults({
			cc,
			rmsid
		})
		.then(results => {
			let skiResults = model.get('skiResults') || {};
			let resultsMap = {};
			if (results && results.length) {
				resultsMap = results.reduce((acc, r) => {
					acc[r.uid] = r;
					return acc;
				}, {});
			}

			skiResults = _.assign({}, skiResults, {
				[rmsid]: resultsMap
			});
			model.set('skiResults', skiResults);
		});
};

const studentGetReadingMindsetSnapshotWorkspace = () => {
	return assignmentService.studentGetReadingMindsetSnapshotWorkspace().then(resp => {
		if (resp) {
			model.set('rmsWorkspace', resp);
		}
	});
};

module.exports = {
	getSKIProduct,
	getSKIActiveAssignment,
	getSKIAssignments,
	getSKIResults,
	scheduleSKI,
	rescheduleSKI,
	cancelSKI,
	endSKI,
	studentGetSKIAssignment,
	submitSKI,
	studentGetReadingMindsetSnapshotWorkspace
};
